<template>
    <div class="service-page global-ad">
        <NavBar :white="true" />
        <Masthead :className="`global-ad`" :activeService="3" title="世界中のターゲットへ<br/>届く広告" category="広告配信" :image="require(`../../assets/global-ad/icon_Global_Advertising.svg`)"/>
        <GlobalAdContent />
        <ServiceBox :activeService="3"/>
        <OurWork />
    </div>
</template>

<script>
    import Masthead from '../../components/service/Masthead'
    import NavBar from "../../components/NavBar";
    import GlobalAdContent from "../../components/service/GlobalAdContent";
    import ServiceBox from "../../components/service/ServiceBox";
    import OurWork from "../../components/service/OurWork";
    import Configuration from "../../utils/configuration";

    export default {
        name: 'GlobalAd',
        components: {
            NavBar,
            Masthead,
            GlobalAdContent,
            ServiceBox,
            OurWork,
        },
        metaInfo: {
          title: '中国、台湾、東南アジアのデジタル広告、オンライン広告はオロ',
          meta: [
            {
              property: 'description',
              content: 'チケット予約や申し込みの獲得系広告だけでなくECサイトの売上向上や認知度向上を目的としたオンライン広告運用を得意としています。複数国を同じ運用会社で同じKPIで管理することでクライアントのリソース負荷軽減だけでなくパフォーマンスの改善も容易です。',
              vmid: 'description'
            },
            {
              property: 'og:title',
              content: '中国、台湾、東南アジアのデジタル広告、オンライン広告はオロ',
              vmid: 'og:title'
            },
            {
              property: 'og:url',
              content: 'https://www.oro.com/global/service/global-ad',
              vmid: 'og:url'
            },
            {
              property: 'og:type',
              content: Configuration.site.meta.og_type,
              vmid: 'og:type'
            },
            {
              property: 'og:site_name',
              content: Configuration.site.meta.og_site_name,
              vmid: 'og:site_name'
            }
          ]
        }
    }
</script>

<style lang="scss">
    .service-page {
        background: #F8F8F8;
        .narbar-menu.bg-white {
            background: #F8F8F8 !important;
        }
        .narbar-menu.bg-dropdown {
            background: #FFF !important;
        }
        .narbar-menu.bg-white.menu-open {
            background: none !important;
        }
        section {
            > .container {
                padding-top: 100px;
                padding-bottom: 100px;
            }

            h5.sub_title {
                font-size: 28px;
                letter-spacing: 1.4px;
                line-height: 40px;
                margin-bottom: 70px;
                font-weight: 700;
            }

            p.sub_content {
                font-size: 16px;
                letter-spacing: 0.8px;
                line-height: 30px;
                margin-bottom: 0;
                font-weight: 400;
                margin-top: 60px;
            }
        }

        .hover-anim {
            &:hover {
                .img-area {
                    img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                    .img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                }
            }
        }

        .mb {
            .hover-anim {
                .img-area {
                    img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                    .img {
                        -webkit-filter: none;
                        -moz-filter: none;
                        filter: none;
                    }
                }
            }
        }

        .img-area {
            img {
                margin-right: 1.5rem;
                height: auto;
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                filter: grayscale(100%);
                transition: all .5s ease;
                object-fit: contain;
                object-position: left;
                max-width: 100%;

                &:last-child {
                    margin-right: 0;
                }
            }
            .img {
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                filter: grayscale(100%);
            }
        }

        i {
            &.arrow-right {
                display: inline-block;
                width: 63px;
                height: 13px;
                background: url(../../assets/icons/arrow-right-dark.svg) no-repeat center right;
                background-size: contain;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .service-page {
            section {
                > .container {
                    padding-top: 70px;
                    padding-bottom: 70px;
                }
                h5.sub_title {
                    font-family: 'Noto Sans JP', sans-serif;
                    color: #333333;
                    font-size: 24px;
                    line-height: 1.46;
                    margin-bottom: 35px;
                }
                p.sub_content {
                    font-family: 'Noto Sans JP', sans-serif;
                    color: #333333;
                    font-size: 15.5px;
                    margin-top: 25px;
                }
            }

            .img-area {
                img {
                    width: 100% !important;
                    max-width: 100% !important;
                    margin-right: 0;
                    -webkit-filter: none;
                    -moz-filter: none;
                    filter: none;
                    &.sp-mb-25 {
                        margin-bottom: 25px;
                    }
                }
                .img {
                    width: 100% !important;
                    margin-right: 0;
                    -webkit-filter: none;
                    -moz-filter: none;
                    filter: none;
                }
            }
        }
    }

    @media screen and (min-width: 1920px) {
        .service-page {
            .container {
                max-width: 1364px;
            }

            .container.full {
                max-width: 1920px;
            }
        }
    }

    @media screen and (max-width: 1919px) and (min-width: 1494px) {
        .service-page {
            .container {
                max-width: 1364px;
            }

            .container.full {
                max-width: 100%;
            }
        }
    }

    @media screen and (max-width: 1493px) and (min-width: 1280px) {
        .service-page {
            .container {
                max-width: calc(100% - 110px);
            }

            .container.full {
                max-width: 100%;
            }
        }
    }
</style>
